<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * User grid component
 */
export default {
  page: {
    title: "Diamond Pot",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Diamond Pot",
        items: [
            {
                text: "Diamond Pot",
                active: true,
            },
            {
                text: "Tracker",
            },
        ],
    };
  },
  mounted: async function() {
    this.initPage();
  },
  watch: {
    walletConnected () {
      this.initPage();
    }
  },
  computed: {
    walletConnected() {
      return this.$store.getters['wallet/validWallet'];
    },
  },
  methods: {
    initPage: function() {
      console.log("Init Page");
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- <div class="row" v-if="$store.getters['wallet/validWallet']">
      <h5>Diamond Pot</h5>
    </div> -->
    <!-- end row -->
  </Layout>
</template>
